import { createFileRoute } from '@tanstack/react-router';

import { TelephonyAgentListScreen } from '@/features/telephony/components/TelephonyAgentListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/telephony/agents')({
  beforeLoad: () => {
    requirePermission('did_mapping:read');
  },
  component: WorkspaceTelephonyAgentsRoute,
  staticData: { crumb: 'Helpline agents' },
});

function WorkspaceTelephonyAgentsRoute() {
  return <TelephonyAgentListScreen surface="workspace" />;
}
